<a
  [routerLink]="
    productCardData()?._id ? '/products/' + productCardData()?._id : ''
  "
  class="product-card"
  [class.product-card--listing]="compact()">
  @if (!compact() && productCardData()?.stone_grade) {
    <div class="product-card__header">
      <p class="product-card__grade">
        <span class="grade-text">
          {{ 'enums.grades.' + productCardData()?.stone_grade | translate }}
        </span>
      </p>
    </div>
  }

  @if (compact()) {
    <div class="product-card__listing-media">
      <img
        class="product-card__listing-image"
        [ngSrc]="
          productCardData()?.main_photo?.cropped_url?.toLowerCase() ||
            productCardData()?.images?.[0]?.cropped_url?.toLowerCase() ||
            productCardData()?.images?.[0]?.url | imageSource
        "
        [width]="400"
        [height]="300"
        [alt]="(productCardData()?.title | translateData) || ''" />

      @if (isFavoriteMode()) {
        <button
          class="product-card__favorite-button"
          (click)="removeProductFromFavorite($event)">
          <img
            class="product-card__favorite-icon"
            ngSrc="assets/icons/heart.svg"
            width="30"
            height="30"
            alt="favorite" />
        </button>
      }

      @if (productCardData()?.code) {
        <div class="product-card__listing-code">
          {{ productCardData()?.code }}
        </div>
      }
    </div>

    <div class="product-card__listing-info">
      <div class="product-card__listing-text">
        <h3 class="product-card__listing-title">
          {{ productCardData()?.title | translateData }}
        </h3>
        <p class="product-card__listing-subtitle">
          {{ productCardData()?.category_type?.title | translateData }}
        </p>
      </div>
    </div>

    <div class="product-card__listing-footer">
      <span class="product-card__listing-price-label">
        {{ 'products.priceRange' | translate }}
      </span>
      <pwj-item-prices
        class="product-card__listing-prices"
        [compact]="true"
        [highestPrice]="productCardData()?.highest_price"
        [lowestPrice]="productCardData()?.lowest_price"></pwj-item-prices>
    </div>
  } @else {
    <!-- product card body -->
    <div
      class="product-card__body"
      [ngClass]="{
        'mt-14 sm:mt-20': !!productCardData()?.stone_grade,
        'mt-0': !productCardData()?.stone_grade,
      }">
      <div class="product-card__image-container">
        <img
          class="product-card__image"
          [ngSrc]="
            productCardData()?.main_photo?.cropped_url?.toLowerCase() ||
              productCardData()?.images?.[0]?.cropped_url?.toLowerCase() ||
              productCardData()?.images?.[0]?.url | imageSource
          "
          [width]="268"
          [height]="268"
          alt="" />

        @if (isFavoriteMode()) {
          <button
            class="product-card__favorite-button"
            (click)="removeProductFromFavorite($event)">
            <img
              class="product-card__favorite-icon"
              ngSrc="assets/icons/heart.svg"
              width="30"
              height="30"
              alt="favorite" />
          </button>
        }

        <div class="product-card__code">
          {{ productCardData()?.code }}
        </div>
      </div>

      <div class="product-card__supplier">
        <pwj-card-title
          class="product-card__supplier-title"
          [cardTitleData]="cardTitleData()"></pwj-card-title>

        @if (productCardData()?.business) {
          <div class="product-card__supplier-flag">
            <i
              [class]="
                'flag-icon flags flag:' +
                productCardData()?.origin_country?.iso
              "></i>
          </div>
        }
      </div>
    </div>

    <div class="product-card__footer">
      <div class="product-card__price">
        <p class="price-label">{{ 'products.priceRange' | translate }}</p>
        <pwj-item-prices
          [compact]="compact()"
          [highestPrice]="productCardData()?.highest_price"
          [lowestPrice]="productCardData()?.lowest_price"></pwj-item-prices>
      </div>
    </div>
  }
</a>
